import React from 'react';

export default function CatatanIssue() {
  return (
    <div className="p-6">
      <h1 className="text-2xl font-bold mb-4">Catatan & Issue</h1>
      <p className="text-gray-500">Halaman Catatan & Issue</p>
    </div>
  );
}
